const format = {
    style: "currency",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};

const noDecimals = {
    style: "currency",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
};

const exported = {
    number: {
        currency: format,
        currencyJPY: noDecimals,
        moneyNoCurrency: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    }
};

export default exported;

export const { number } = exported;
